interface Lv95Coordinate {
  x: number;
  y: number;
}

const calculateCenterOfPolygon = (pCoordinates: Lv95Coordinate[]): Lv95Coordinate => {
  let sumX = 0;
  let sumY = 0;

  for (let i = 0; i < pCoordinates.length; i++) {
    sumX += pCoordinates[i].x;
    sumY += pCoordinates[i].y;
  }

  return {
    x: sumX / pCoordinates.length,
    y: sumY / pCoordinates.length,
  };
};

export { calculateCenterOfPolygon };
